import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';
import { StorageImageComponent } from './storage-image.component';
import { ProgressbarModule } from 'ngx-bootstrap';
import { ProgramProgressBar } from './program-progress-bar.component';
import { ProgramMapPipe } from './program-map.pipe';
import { UnsavedGuard } from './unsaved.guard';
import { UploadService } from './upload.service';
import { auditLogService } from '../services/auditLog.service';

@NgModule({
  imports: [
    CommonModule,
    ProgressbarModule.forRoot(),
  ],
  declarations: [
    StorageImageComponent,
    ProgramProgressBar,
    ProgramMapPipe
  ],
  exports: [
    StorageImageComponent,
    ProgramProgressBar,
    ProgramMapPipe
  ],
  providers: [
    AuthService,
    AuthGuard,
    UnsavedGuard,
    UploadService,
    auditLogService,
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/core/core.module.ts